import { UserNetworkLeader } from '@ms/yammer-data/dist/state/types';

import { trimBasenameFromUrlPath } from '../location';

export const adminSettingsUrl = '/admin';
export const adminSettingsLeadershipIdentificationUrl = '/admin/leadership-identification';
export const adminSettingsManageDataUrl = '/admin/data-export';
export const adminSettingsManageLeaderUrl = '/admin/leadership-identification/manage/:userId';
export const adminSettingsManageRolesUrl = '/admin/manage-roles';
export const adminSettingsTenantSettingsUrl = '/admin/tenant-settings';
export const adminSettingsManageStorylineUrl = '/admin/storyline';
export const adminSettingsManageStorylineAdvancedUrl = '/admin/storyline/advanced';
export const adminSettingsManageUserAchievementsUrl = '/admin/manage-achievements';
export const adminSettingsNetworkQuestionsUrl = '/admin/network-questions';
export const adminSettingManageAnalyticsUrl = '/admin/analytics';
export const adminSettingsLeadershipCornerUrl = '/admin/leadership-corner';
export const adminSettingsDesignateLeaderUrl = '/admin/leadership-identification/designate-leader';
export const adminSettingsMTOPolicyUrl = '/admin/mto-policy';

export const queryParamSelected = 'selected';

type AdminSettingsManageLeaderPageWithLeaderId = (leaderId: UserNetworkLeader['id']) => string;
export const adminSettingsManageLeaderPageWithLeaderId: AdminSettingsManageLeaderPageWithLeaderId = (leaderId) =>
  adminSettingsManageLeaderUrl.replace(':userId', leaderId);

type IsAdminSettingsSubRoute = (pathname: string) => boolean;
export const isAdminSettingsSubRoute: IsAdminSettingsSubRoute = (pathname: string) => {
  const trimedPath = trimBasenameFromUrlPath(pathname);

  return trimedPath.startsWith('/admin') && !(trimedPath.endsWith('admin') || trimedPath.endsWith('admin/'));
};
